import { render } from "./api-keys.vue?vue&type=template&id=193dfb17"
import script from "./api-keys.vue?vue&type=script&lang=js"
export * from "./api-keys.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__